import { DefinedPropertyObject, IEntityMinimalModel } from "../../api/GenericTypes";
import { DataFormat, DataFormatFilters, DataFormatFieldLabels } from "../../api/DataFormats";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { EntityFilterSideBar } from "../../common/sidebar/filtersidebar/EntityFilterBar";
import { MethodsVirtualizedSelectForm } from "../../common/forms/EntityForms/formsVirtualized/MethodsVirtualizedSelectForm";
import { VendorsVirtualizedSelectForm } from "../../common/forms/EntityForms/formsVirtualized/VendorsVirtualizedSelectForm";
import { DataFormatInstrumentsVirtualizedSelectForm } from "../../common/forms/EntityForms/formsVirtualized/DataFormatInstrumentsVirtualizedSelectForm";
import { useContext } from "react";
import { SessionContext } from "../../common/contexts/SessionContext";
import { ToggleFormField } from "../../common/formfields/ToggleFormField";
import { defaultDataFormatFilters } from "./DataFormatsTable";
export interface DataFormatFilterForm {
  methods?: IEntityMinimalModel<string>[] | undefined | null;
  vendors?: IEntityMinimalModel<string>[] | undefined | null;
  instruments?: IEntityMinimalModel<string>[] | undefined | null;
  isBeta?: boolean | undefined | null;
  isCustom?: boolean | undefined | null;
  hasVisualization?: boolean | undefined | null;
}
const defaultValues: DefinedPropertyObject<DataFormatFilterForm> = {
  methods: null,
  vendors: null,
  instruments: null,
  isBeta: null,
  isCustom: null,
  hasVisualization: null,
};
export const dataFormatsFormToFilters = (form: DataFormatFilterForm): DataFormatFilters => {
  let filters: DataFormatFilters = {};

  filters.methodIds = Array.isArray(form.methods) && form.methods.length > 0 ? form.methods?.map((d) => d.id) : null;
  filters.vendorIds = Array.isArray(form.vendors) && form.vendors.length > 0 ? form.vendors?.map((d) => d.id) : null;
  filters.instrumentIds =
    Array.isArray(form.instruments) && form.instruments.length > 0 ? form.instruments?.map((d) => d.id) : null;
  filters.isBeta = form.isBeta ?? null;
  filters.isCustom = form.isCustom ?? null;
  filters.hasVisualization = form.hasVisualization ?? null;

  return filters;
};
/**
 * Converts ParserFilters to ParserFilterForm
 * @param filters ParserFilters
 * @returns ParserFilterForm
 * @author @CorradoSurmanowicz
 */
export const filtersToDataFormatsForm = (filters: DataFormatFilters): DataFormatFilterForm => {
  let form: DataFormatFilterForm = {};

  form.methods = filters.methodIds?.map((name) => ({ id: name ?? "", name: name ?? "" })) || null;
  form.vendors = filters.vendorIds?.map((name) => ({ id: name ?? "", name: name ?? "" })) || null;
  form.instruments = filters.instrumentIds?.map((name) => ({ id: name ?? "", name: name ?? "" })) || null;
  form.isBeta = filters.isBeta;
  form.isCustom = filters.isCustom;
  form.hasVisualization = filters.hasVisualization;

  return form;
};

export const DataFormatFilterBar = ({
  initialValues,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<DataFormat, DataFormatFilterForm, DataFormatFilters>) => {
  const { session } = useContext(SessionContext);

  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultDataFormatFilters}
      formToFilters={dataFormatsFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <VendorsVirtualizedSelectForm
            id="vendors"
            label={DataFormatFieldLabels.vendors}
            control={control}
            isMulti
            // allowUnassigned
          />
          <MethodsVirtualizedSelectForm
            id="methods"
            label={DataFormatFieldLabels.methods}
            control={control}
            isMulti
            // allowUnassigned
          />
          <DataFormatInstrumentsVirtualizedSelectForm
            id="instruments"
            label={DataFormatFieldLabels.instruments}
            control={control}
            isMulti
            // allowUnassigned
          />

          <ToggleFormField
            id="hasVisualization"
            control={control}
            label={DataFormatFieldLabels.hasVisualization}
            horizontal
            allowIntermediate
          />

          <ToggleFormField
            id="isCustom"
            control={control}
            label={DataFormatFieldLabels.isCustom}
            horizontal
            allowIntermediate
          />

          {session?.features.development_mode && (
            <>
              <ToggleFormField
                id="isBeta"
                control={control}
                label={DataFormatFieldLabels.isBeta}
                horizontal
                allowIntermediate
              />
            </>
          )}
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
